import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

import messages from "../utils/messages";
import { TextField, CheckboxFeild } from "./InputFeild";
import logo_image from "../assets/images/big_logo.png";
import { adminLogin } from "../api/network/auth";
import email_svg from "../assets/images/input-email.svg";
import password_svg from "../assets/images/input-password.svg";
import SaveButton from "../component/SaveButton";
const initial_data = () => {
  let credentialString = "";
  if ((credentialString = Cookies.get("bpp-admin-credential"))) {
    return JSON.parse(credentialString);
  } else {
    return {
      email: "",
      password: "",
    };
  }
};

const Login = ({ formData = initial_data() }) => {
  // const handleError = useErrorHandler();
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();
  const ContactSchema = Yup.object().shape({
    email: Yup.string().required(messages.required.email).email(messages.email),
    password: Yup.string().required(messages.required.password),
  });
  const formik = useFormik({
    initialValues: {
      ...formData,
    },
    validationSchema: ContactSchema,

    onSubmit: (values) => {
      console.log("values :>> ", values);
      if (values.remember)
        Cookies.set("bpp-admin-credential", JSON.stringify(values));
      setShowSpinner(true);
      adminLogin("post", "auth/login", values)
        .then((result) => {
          // console.log("result.data.token", result.data.token);
          localStorage.setItem("admin_token", result.data.token);
          navigate("/lovedone/list");
        })
        .catch((error) => {
          console.log(error, "errorrrrrrrrrrrrrrrrrrrrrrrr:>>>>>>>>>>");
        })
        .finally(() => {
          setShowSpinner(false);
        });
    },
    enableReinitialize: true,
  });
  return (
    <div className="outer">
      <aside className="sidebar-login">
        <div className="m-auto">
          <img src={logo_image} alt="" />
        </div>
      </aside>

      <main className="main-body">
        <div className="content">
          <div className="row flex-fill g-4">
            <div className="col-md-12 d-flex align-items-center justify-content-center">
              <div className="outer-box">
                <div className="outer-box-header">
                  <h1 style={{ fontSize: "30px" }}>
                    <span>Welcome!</span>BigPurplePhone Admin Panel
                  </h1>
                </div>
                <form>
                  <div className="row g-3">
                    <div class="col-md-12">
                      <div class="boxInput">
                        <TextField
                          formik={formik}
                          name="email"
                          placeholder="Email"
                          icon="email"
                          type="email"
                        />
                        <span class="iputIcons">
                          <img src={email_svg} alt="" />
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="boxInput">
                        <TextField
                          formik={formik}
                          name="password"
                          placeholder="Password"
                          icon="password"
                          type="password"
                        />
                        <span class="iputIcons">
                          <img src={password_svg} alt="" />
                        </span>
                      </div>
                    </div>

                    <div className="col-md-12"></div>
                    <div className="col-md-12">
                      <div className="form-check d-flex align-items-center">
                        <CheckboxFeild
                          formik={formik}
                          name="remember"
                          label="Remember me"
                        />
                      </div>
                    </div>
                    <div className="col-md-12 pt-2">
                      <SaveButton
                        handleSubmit={formik.handleSubmit}
                        showSpinner={showSpinner}
                        text="Login"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="footer">
        <p>© 2022 BigPurple, all rights reserved.</p>
      </footer>
    </div>
  );
};
export default Login;
